<template>
  <div>
    <div class="vx-row mt-0">
      <div class="vx-col md:w-1/4 w-full">
        <label class="vs-input--label pl-1">Current GR Reference</label>
        <vs-input
          class="w-full"
          v-model="oldReference"
          placeholder="Enter current GR reference"
          @keyup.enter="searchPreview"
        />
      </div>
      <div class="vx-col md:w-1/4 w-full" style="display:flex;align-items:flex-end;">
        <vs-button
          color="warning"
          class="btn mb-4 md:mb-0"
          @click="searchPreview"
          :disabled="oldReference == ''"
        >
          Search
        </vs-button>
      </div>
    </div>

    <!-- Preview Section -->
    <div class="vx-row mt-6" v-if="showPreview" style="display:flex;align-items:stretch;">
      <div class="vx-col md:w-1/2 w-full" style="display:flex;">
        <vs-card style="width:100%;display:flex;flex-direction:column;">
          <div slot="header">
            <span style="font-size:14px;font-weight:600;">GR Details</span>
          </div>
          <div style="max-height: 300px; overflow-y: auto;flex:1;">
            <table style="width:100%">
              <thead>
                <tr>
                  <th style="padding:4px 0;text-align:left;border-bottom:1px solid #ddd;">Product</th>
                  <th style="padding:4px 0;text-align:left;border-bottom:1px solid #ddd;">Qty</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(detail, index) in previewData.details" :key="index">
                  <td style="padding:4px 0;border-bottom:1px solid #eee;">{{ detail.product }}</td>
                  <td style="padding:4px 0;border-bottom:1px solid #eee;">{{ detail.qty }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </vs-card>
      </div>

      <div class="vx-col md:w-1/2 w-full" style="display:flex;">
        <vs-card style="width:100%;display:flex;flex-direction:column;">
          <div slot="header">
            <span style="font-size:14px;font-weight:600;">Records Akan Diupdate</span>
          </div>
          <table style="width:100%">
            <tr>
              <td style="padding:4px 0;font-weight:bold;width:50%;">GR (Good Receive)</td>
              <td style="padding:4px 0;">1 record</td>
            </tr>
            <tr>
              <td style="padding:4px 0;font-weight:bold;">Inventories Transactions</td>
              <td style="padding:4px 0;">{{ previewData.transactions_count }} record(s)</td>
            </tr>
            <tr>
              <td style="padding:4px 0;font-weight:bold;">Movement Order Details</td>
              <td style="padding:4px 0;">{{ previewData.movement_count }} record(s)</td>
            </tr>
          </table>
        </vs-card>
      </div>
    </div>

    <!-- New Reference Input -->
    <div class="vx-row mt-6" v-if="showPreview">
      <div class="vx-col md:w-1/4 w-full">
        <label class="vs-input--label">New GR Reference</label>
        <vs-input
          class="w-full"
          v-model="newReference"
          placeholder="Enter new GR reference"
          @keyup.enter="submitForm"
        />
      </div>
      <div class="vx-col md:w-1/4 w-full" style="display:flex;align-items:flex-end;">
        <vs-button
          color="primary"
          class="btn mb-4 md:mb-0"
          @click="submitForm"
        >
          Process
        </vs-button>
      </div>
    </div>

    <!-- Confirm Modal -->
    <vs-popup title="Konfirmasi Update GR Reference" :active.sync="showConfirmModal">
      <p style="margin-bottom:12px;">Apakah kamu yakin ingin memperbarui GR reference?</p>
      <table style="width:100%;margin-bottom:16px;">
        <tr>
          <td style="padding:4px 0;font-weight:bold;width:40%;">Current Reference</td>
          <td style="padding:4px 0;">{{ oldReference }}</td>
        </tr>
        <tr>
          <td style="padding:4px 0;font-weight:bold;">New Reference</td>
          <td style="padding:4px 0;">{{ newReference }}</td>
        </tr>
      </table>
      <div style="display:flex;justify-content:flex-end;">
        <vs-button color="grey" class="btn mr-2" @click="showConfirmModal = false">Batal</vs-button>
        <vs-button color="primary" class="btn" @click="confirmUpdate">Ya, Update</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: "ChangeGoodReceiveReference",
  data() {
    return {
      oldReference: "",
      newReference: "",
      previewData: null,
      showPreview: false,
      showConfirmModal: false,
    };
  },
  methods: {
    searchPreview() {
      if (this.oldReference == "") {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "Old GR Reference is required",
        });
        return false;
      }

      this.$emit("loading", true);
      this.showPreview = false;

      this.$http
        .post("support/inbound/gr/preview", {
          reference: this.oldReference,
        })
        .then((res) => {
          this.$emit("loading", false);
          this.previewData = res.data.data;
          this.showPreview = true;
          this.newReference = "";
        })
        .catch((error) => {
          this.$emit("loading", false);
          this.$emit("error", error);
        });
    },

    submitForm() {
      if (this.newReference == "") {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "New GR Reference is required",
        });
        return false;
      }

      if (this.oldReference === this.newReference) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "Old and new reference are the same",
        });
        return false;
      }

      this.showConfirmModal = true;
    },

    confirmUpdate() {
      this.showConfirmModal = false;
      this.$emit("loading", true);
      this.$http
        .post("support/inbound/gr/update", {
          old_reference: this.oldReference,
          new_reference: this.newReference,
        })
        .then((res) => {
          this.$emit("loading", false);
          const data = res.data.data;
          this.$vs.notify({
            color: "success",
            title: "Success",
            iconPack: "feather",
            icon: "icon-check",
            text: `GR reference "${data.old_reference}" berhasil diperbarui menjadi "${data.new_reference}".`,
          });
          this.oldReference = "";
          this.newReference = "";
          this.previewData = null;
          this.showPreview = false;
        })
        .catch((error) => this.$emit("error", error));
    },
  },
};
</script>
